import React, { useState, useEffect } from "react";
import TauriImage from "../TauriImage/TauriImage";
import './TauriBrand.css';
import OpalIncidentalCallModal from "../OpalIncidentalCallModal/OpalIncidentalCallModal";
import OpalAlertModal from "../OpalAlertModal/OpalAlertModal";
import { useBaseProvider } from "../../BaseManager/BaseManager";
import { getAll } from "../../localDB";
import { SyncStatusMap } from "../../visualizations/visualizations";

const TauriBrand = ({ brand }) => {
    const [showIncidental, setShowIncidental] = useState(false);
    const [showValidation, setShowValidation] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');

    const storedPermission = localStorage.getItem("permission");
    const permission = JSON.parse(atob(storedPermission));

    const { isSync, timeIn, timeOut, setTimeIn, setTimeOut } = useBaseProvider();

    const handleIconClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (isSync) {
            setValidationMessage("Your data is syncing.");
            setShowValidation(true);
            return;
        } else if (!permission?.coverage?.incidental_calls) {
            setValidationMessage("You don't have the permission to do this action.");
            setShowValidation(true);
            return;
        } else if (!timeIn) {
            setValidationMessage("You have to do Start of Day before starting to do a Session.");
            setShowValidation(true);
            return;
        } else if (timeOut) {
            setValidationMessage("You have already ended your day of work today. You may do this action on the next day.");
            setShowValidation(true);
            return;
        }

        setShowIncidental(true);
    };

    useEffect(() => {
        const checkAttendance = async () => {
            try {
                const todayDate = new Date();
                todayDate.setHours(0, 0, 0, 0);

                const attendance = await getAll("Attendance");
                const todayAttendance = attendance
                    .filter(a => a.SyncStatus !== SyncStatusMap.done)
                    .find((a) => {
                        const timeInDate = new Date(a?.TimeIn);
                        timeInDate.setHours(0, 0, 0, 0); // normalize

                        return timeInDate.getTime() === todayDate.getTime();
                    });

                setTimeIn(todayAttendance?.TimeIn ? true : false);
                setTimeOut(todayAttendance?.TimeOut ? true : false);

            } catch (error) {
                setValidationMessage("attendance not found!");
                setShowValidation(true);
            }
        };

        checkAttendance();
    }, [])

    return (
        <>
            <a className="navbar-brand col-md-3 col-lg-3 col-xl-3 col-xxl-2 m-0 me-md-2" href="#">
                <div className="brand-group">
                    {brand?.brandImage ? (
                        <div
                            className="d-none d-sm-block"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                maxWidth: '110px'
                            }}
                        >
                            <TauriImage
                                localImage={brand.brandImage}
                                alt={brand?.brandName || 'Brand Logo'}
                                className="img-fluid"
                                color="#FFFFFF"
                            />
                        </div>
                    ) : (
                        <>
                            <span className="brandname d-none d-sm-block">
                                {brand?.brandName}
                            </span>
                            <span className="sub-brand d-none d-xl-block">
                                {brand?.subBrandName}
                            </span>
                        </>
                    )}
                </div>
                <div className="brand-icon">
                    <TauriImage localImage="/Images/flat-color-icons--plus.svg" onClick={handleIconClick} alt="brand-icon" />
                </div>
            </a>

            <OpalIncidentalCallModal
                show={showIncidental}
                onHide={() => setShowIncidental(false)}
                incidentalJointCall={permission?.coverage?.IncidentalJointCall}
            />
            <OpalAlertModal
                show={showValidation}
                onHide={() => {
                    setShowValidation(false);
                }}
                title={"Message"}
                bodyText={validationMessage}
                modalType="message"
            />
        </>
    );
};

export default TauriBrand;